module.exports = __webpack_public_path__ + "img/product-shot_01_loading.46a185e4.jpg";